import Header from 'app/layout/components/header/Header';
import { StyledAccountMarginTop } from 'app/layout/components/Layout.styled';
import { lazyWithRetry } from 'utils/helpers';

const Account = lazyWithRetry(() => import('pages/Account'));

const NoAccessAccount = () => (
  <>
    <Header isSearch={false} />
    <StyledAccountMarginTop>
      <Account />
    </StyledAccountMarginTop>
  </>
);
export default NoAccessAccount;
